import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';
const t = key => app.translator.trans('ppk2-profile.forum.password_eye.' + key);

/**
 * v17 «Показать пароль»: an eye button right after a password input (both inside `.Ppk2Pw`).
 * The shown state is kept on the input element (`__ppk2Reveal`), so enforceType()
 * (AccountModals.js) keeps type=text while shown and type=password otherwise.
 */
export default class PasswordEye extends Component {
  input() {
    return this.element && this.element.parentNode ? this.element.parentNode.querySelector('input') : null;
  }

  /** after every redraw: a shown password stays shown (some forms re-render type="password") */
  onupdate(vnode) {
    super.onupdate && super.onupdate(vnode);
    const el = this.input();
    if (el && el.__ppk2Reveal && el.getAttribute('type') !== 'text') el.setAttribute('type', 'text');
  }
  view() {
    const el = this.input();
    const on = !!(el && el.__ppk2Reveal);
    const label = t(on ? 'hide' : 'show');
    return m("button", {
      type: "button",
      className: 'Button Button--icon Button--link Ppk2PwEye' + (on ? ' is-on' : ''),
      title: label,
      "aria-label": label,
      "aria-pressed": on ? 'true' : 'false',
      onmousedown: e => e.preventDefault(),
      onclick: e => {
        e.preventDefault();
        const input = this.input();
        if (!input) return;
        input.__ppk2Reveal = !input.__ppk2Reveal;
        input.setAttribute('type', input.__ppk2Reveal ? 'text' : 'password');
        input.focus();
      }
    }, m(Icon, {
      name: on ? 'fas fa-eye-slash' : 'fas fa-eye'
    }));
  }
}

/** `<span class="Ppk2Pw">input + eye</span>` */
export function withEye(input) {
  return m("span", {
    className: "Ppk2Pw"
  }, input, m(PasswordEye, null));
}
flarum.reg.add('ppk2-profile', 'forum/components/PasswordEye', PasswordEye);